export const createIndex = (i,j, maxJ = 5) =>{
  return maxJ*(i)+j;
}